// This file is auto-generated by @hey-api/openapi-ts

import type { RequestResult } from '../client';
import { client } from '../client.gen';
import type { Options } from '../sdk.gen';
import type { DetailUsingPostData, DetailUsingPostErrors, DetailUsingPostResponses, LevelUsingPostData, LevelUsingPostErrors, LevelUsingPostResponses, LoginUsingPostData, LoginUsingPostErrors, LoginUsingPostResponses, LogoutUsingPostData, LogoutUsingPostErrors, LogoutUsingPostResponses, RegisterUsingPostData, RegisterUsingPostErrors, RegisterUsingPostResponses, UpdateInfoUsingPostData, UpdateInfoUsingPostErrors, UpdateInfoUsingPostResponses, UpdatePsdUsingPostData, UpdatePsdUsingPostErrors, UpdatePsdUsingPostResponses } from '../types.gen';

export class DesktopUserControllerService {
    /**
     * detail
     */
    public static detailUsingPost<ThrowOnError extends boolean = false>(options?: Options<DetailUsingPostData, ThrowOnError>): RequestResult<DetailUsingPostResponses, DetailUsingPostErrors, ThrowOnError> {
        return (options?.client ?? client).post<DetailUsingPostResponses, DetailUsingPostErrors, ThrowOnError>({ url: '/v1/desktop/detail', ...options });
    }
    
    /**
     * level
     */
    public static levelUsingPost<ThrowOnError extends boolean = false>(options?: Options<LevelUsingPostData, ThrowOnError>): RequestResult<LevelUsingPostResponses, LevelUsingPostErrors, ThrowOnError> {
        return (options?.client ?? client).post<LevelUsingPostResponses, LevelUsingPostErrors, ThrowOnError>({ url: '/v1/desktop/level', ...options });
    }
    
    /**
     * login
     */
    public static loginUsingPost<ThrowOnError extends boolean = false>(options?: Options<LoginUsingPostData, ThrowOnError>): RequestResult<LoginUsingPostResponses, LoginUsingPostErrors, ThrowOnError> {
        return (options?.client ?? client).post<LoginUsingPostResponses, LoginUsingPostErrors, ThrowOnError>({
            url: '/v1/desktop/login',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * logout
     */
    public static logoutUsingPost<ThrowOnError extends boolean = false>(options?: Options<LogoutUsingPostData, ThrowOnError>): RequestResult<LogoutUsingPostResponses, LogoutUsingPostErrors, ThrowOnError> {
        return (options?.client ?? client).post<LogoutUsingPostResponses, LogoutUsingPostErrors, ThrowOnError>({ url: '/v1/desktop/logout', ...options });
    }
    
    /**
     * register
     */
    public static registerUsingPost<ThrowOnError extends boolean = false>(options?: Options<RegisterUsingPostData, ThrowOnError>): RequestResult<RegisterUsingPostResponses, RegisterUsingPostErrors, ThrowOnError> {
        return (options?.client ?? client).post<RegisterUsingPostResponses, RegisterUsingPostErrors, ThrowOnError>({
            url: '/v1/desktop/register',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * updateInfo
     */
    public static updateInfoUsingPost<ThrowOnError extends boolean = false>(options?: Options<UpdateInfoUsingPostData, ThrowOnError>): RequestResult<UpdateInfoUsingPostResponses, UpdateInfoUsingPostErrors, ThrowOnError> {
        return (options?.client ?? client).post<UpdateInfoUsingPostResponses, UpdateInfoUsingPostErrors, ThrowOnError>({
            url: '/v1/desktop/update',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * updatePsd
     */
    public static updatePsdUsingPost<ThrowOnError extends boolean = false>(options?: Options<UpdatePsdUsingPostData, ThrowOnError>): RequestResult<UpdatePsdUsingPostResponses, UpdatePsdUsingPostErrors, ThrowOnError> {
        return (options?.client ?? client).post<UpdatePsdUsingPostResponses, UpdatePsdUsingPostErrors, ThrowOnError>({
            url: '/v1/desktop/update/psd',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
}
